import { Components, Theme } from '@mui/material';

export const MuiLink: Components<Omit<Theme, 'components'>>['MuiLink'] = {
  defaultProps: {
    underline: 'hover',
  },
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: theme.typography.fontSize,
      color: theme.palette.primary.main,
    }),
  },
};
